export enum EstateTaxFormTypeKey {
  AUTH_REP_FORM = 'auth_rep_form',
  T1 = 't1',
  T3 = 't3',
  T1_ADJUSTMENT = 't1_adjustment',
  T3_ADJUSTMENT = 't3_adjustment',
  CLEARANCE_CERTIFICATE = 'clearance_certificate',
  RC4288 = 'rc4288',
  FORM_56 = 'form_56',
  TEN_FORTY = 'ten_forty',
  TEN_FORTY_ADJUSTMENT = 'ten_forty_adjustment',
  TEN_FORTY_ONE = 'ten_forty_one',
  TEN_FORTY_ONE_ADJUSTMENT = 'ten_forty_one_adjustment',
  IRS_TERMINATION = 'irs_termination'
}
